export default "__VITE_ASSET__e6989b88__"